import {isNullOrUndefined} from "../../../services/Validator";

export default function GlossaryLetterItem({letter, scrollToLetter}) {
    // Used in GlossaryLettersList to display one single letter

    // BUILD
    if (isNullOrUndefined(letter) || isNullOrUndefined(scrollToLetter))
        return null
    return (
        <div className={"cursor-pointer w-[34px] min-w-[34px] h-[40px] min-h-[40px] flex justify-center items-center rounded-[12px]  bg-backgroundLight4  hover:bg-backgroundLight5 border-greyLight5 border-[1px]"}
             onClick={scrollToLetter}>
            <span className={"text-normal text-[14px] text-white"}>
                {letter}
            </span>
        </div>
    );
}